import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-switch-field',
  standalone: true,
  templateUrl: './switch-field.html',
  styleUrl: './switch-field.scss',
})
export class SwitchField {
  @Input() checked = false;
  @Input() disabled = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.checkedChange.emit(input.checked);
  }
}
